/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'locales/en': {
    width: 1200,
    height: 600,
    viewBox: '0 0 60 30',
    data: '<clipPath id="svgicon_locales_en_a"><path pid="0" d="M0 0v30h60V0z"/></clipPath><clipPath id="svgicon_locales_en_b"><path pid="1" d="M30 15h30v15zv15H0zH0V0zV0h30z"/></clipPath><g clip-path="url(#svgicon_locales_en_a)"><path pid="2" d="M0 0v30h60V0z" _fill="#012169"/><path pid="3" d="M0 0l60 30m0-30L0 30" _stroke="#fff" stroke-width="6"/><path pid="4" d="M0 0l60 30m0-30L0 30" clip-path="url(#svgicon_locales_en_b)" _stroke="#C8102E" stroke-width="4"/><path pid="5" d="M30 0v30M0 15h60" _stroke="#fff" stroke-width="10"/><path pid="6" d="M30 0v30M0 15h60" _stroke="#C8102E" stroke-width="6"/></g>'
  }
})
